import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth }   from '../context/AuthContext';
import { useEquipo } from '../context/EquipoContext';

export default function AuthCallback() {
  const navigate           = useNavigate();
  const [searchParams]     = useSearchParams();
  const { loginConToken }  = useAuth();
  const { cambiarDeporte } = useEquipo();

  useEffect(() => {
    const token   = searchParams.get('token');
    const nombre  = searchParams.get('nombre');
    const email   = searchParams.get('email');
    const rol     = searchParams.get('rol')     || 'capitan';
    const id      = searchParams.get('id');

    // Deporte: primero del param, luego del localStorage
    const deporteParam = searchParams.get('deporte');
    const deporteLocal = localStorage.getItem('turival_deporte_login');
    const deporte      = deporteParam || deporteLocal || 'futbol';

    if (!token) { navigate('/login?error=google'); return; }

    loginConToken({ id: parseInt(id), nombre, email, rol }, token);

    // Si viene con deporte específico, guardarlo para que EquipoContext lo use
    if (rol === 'capitan' && deporte !== 'futbol') {
      cambiarDeporte(deporte);
    }
    localStorage.removeItem('turival_deporte_login');

    // Canjear invitación externa si existe (rival externo)
    const invExternaToken = localStorage.getItem('turival_invitacion_externa_token');
    if (invExternaToken && id) {
      fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/invitaciones/externa/${invExternaToken}/canjear`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario_id: parseInt(id) }),
      })
        .then(r => r.json())
        .then(data => {
          if (data.ok) localStorage.removeItem('turival_invitacion_externa_token');
        })
        .catch(() => {});
    }

    // Canjear invitación de compañero si existe
    const invToken = localStorage.getItem('turival_invitacion_token');
    if (invToken && id) {
      fetch(`${process.env.REACT_APP_API_URL || 'http://45.236.131.39:4000'}/api/invitaciones/${invToken}/canjear`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario_id: parseInt(id) }),
      })
        .then(r => r.json())
        .then(data => { if (data.ok) localStorage.removeItem('turival_invitacion_token'); })
        .catch(() => {});
    }

    if (rol === 'arbitro' || rol === 'tercer_tiempo') {
      navigate('/app/panel-proveedor');
    } else if (rol === 'recinto') {
      navigate('/app/panel-recinto');
    } else {
      navigate('/app/dashboard');
    }
  }, []);

  return (
    <div style={{
      minHeight: '100vh', background: '#0D1117',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      flexDirection: 'column', gap: 16,
    }}>
      <div style={{ fontSize: 40 }}>⚡</div>
      <div style={{
        fontFamily: "'Barlow Condensed', sans-serif",
        fontSize: 24, fontWeight: 800, color: 'white',
      }}>
        Iniciando sesión...
      </div>
    </div>
  );
}
